import React, { useEffect } from 'react'
import classes from './password.module.css'
import {
    FormInput,
    ValidatedFormInput,
} from '../../../components/Form/Inputs/Inputs'
import { Button } from '../../../components/Button/Button'
import { Formik } from 'formik'
import { ResetPasswordSchema } from '../../../util/formSchemas'
import usePasswordForm from '../../../hooks/usePasswordForm'

const Password = () => {
    const submitForm = usePasswordForm()

    return (
        <Formik
            initialValues={{
                oldPassword: '',
                newPassword: '',
                confirmNewPassword: '',
            }}
            validationSchema={ResetPasswordSchema}
            onSubmit={submitForm}
        >
            {({ handleSubmit }) => (
                <>
                    <h1 className={classes.passwordHeader}>Password</h1>
                    <p className={classes.passwordSubtext}>
                        Please provide your current password and choose a new
                        password.
                    </p>
                    <div className={classes.passwordInputs}>
                        <ValidatedFormInput
                            label={'Current Password'}
                            name={'oldPassword'}
                            type={'password'}
                        />
                        <ValidatedFormInput
                            label={'New Password'}
                            name={'newPassword'}
                            type={'password'}
                        />
                        <ValidatedFormInput
                            label={'Retype Password'}
                            name={'confirmNewPassword'}
                            type={'password'}
                        />
                    </div>
                    <Button onClick={handleSubmit}>Save Password</Button>
                </>
            )}
        </Formik>
    )
}

export default Password
